import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatFilesize'
})
export class FormatFilesizePipe implements PipeTransform {
    transform(value: number | null) : string {
      let displayValue = '-';
      if (value) {
        if (value > 999999999) {
          displayValue = (value / 1073741824).toFixed(1).toString() + 'GB';
        } else if (value > 999999) {
          displayValue = (value / 1048576).toFixed(1).toString() + 'MB';
        } else {
          displayValue = (value / 1024).toFixed(0).toString() + 'KB';
        }
      }
      return displayValue;
    }
}
